/* eslint-disable */
import {
  Flex,
  Table,
  Tbody,
  Td,
  Text,
  Thead,
  Tr,
  useColorModeValue,
  Button,
  TableCaption,
  Center,
  Stack,
  Input,
  Select,
  useToast,
  Grid,
  GridItem,
  Box,
  Spinner,
  Image,
  Badge,
  Checkbox,
} from "@chakra-ui/react";
// Custom components
import Card from "components/card/Card";
import { HSeparator } from "components/separator/Separator";
import { DownloadIcon, ArrowBackIcon, ArrowForwardIcon } from '@chakra-ui/icons';
import React, { useEffect, useState } from "react";
import { convertDate, URL_WEB_BACKEND, decryptData } from "CustomUtil";
import axios from "axios";
import { utils as xlxUtils, writeFile as xlxWriteFile, write as xlxWrite } from "xlsx";
import { saveAs } from "file-saver";
import { URL_WEB_FORNTEND } from "CustomUtil";

export default function SumasTable() {
  const authdata = decryptData(localStorage.getItem("authinfosemakinpas"));

  const [sumas, setSumas] = useState([]);
  const [statusLoading, setStatusLoading] = useState(false);
  const toast = useToast();

  // pagination
  const [isPagination, setIsPagination] = useState(true);
  const [currentPageNumber, setCurrentPageNumber] = useState(1);
  const [allPageNumber, setAllPageNumber] = useState(0);

  // search
  const [searchClue, setSearchClue] = useState('');
  const [searchCat, setSearchCat] = useState('isisurat');

  const catOpt = [
    { value: 'isisurat', label: 'Isi Ringkas' },
    { value: 'nosurat', label: 'Nomor Surat' },
    { value: 'dari', label: 'Asal Surat' },
    { value: 'disposisike', label: 'Tujuan Disposisi' },
    { value: 'isidisposisi', label: 'Isi Disposisi' },
    { value: 'pengoleh', label: 'Pengoleh' },
  ];

  const textColor = useColorModeValue("secondaryGray.900", "white");

  useEffect(() => {
    if (sumas.length < 1 || sumas === undefined) {
      getSumas(1);
    }
  }, []);

  useEffect(() => {
    getSumas(1);
  }, [searchClue]);

  const getSumas = async (pagesNumber) => {
    setStatusLoading(true);
    setSumas([]);
    if (searchClue === '') {
      setIsPagination(true);
      await axios.get(URL_WEB_BACKEND + '/sumas?page=' + pagesNumber, {
        headers: {
          'Authorization': 'Bearer ' + authdata
        }
      }).then((response) => {
        setSumas(response.data.sumas);
        setAllPageNumber(response.data.pages);
        setStatusLoading(false);
      }).catch(err => {
        setStatusLoading(false);
        toast({
          status: 'error',
          title: 'Error status ' + err.response.status,
          description: 'Data kosong.',
          position: 'bottom-right',
          isClosable: true,
        })
      });
    } else {
      setIsPagination(false);
      await axios.get(URL_WEB_BACKEND + '/cari/sumas/' + searchCat + '/' + searchClue + '?page=' + pagesNumber, {
        headers: {
          'Authorization': 'Bearer ' + authdata
        }
      }).then((response) => {
        setIsPagination(true);
        setSumas(response.data.sumas);
        setAllPageNumber(response.data.pages);
        setStatusLoading(false);
      }).catch(err => {
        setStatusLoading(false);
        toast({
          status: 'error',
          title: 'Error status ' + err.response.status,
          description: 'Tak ada data yang dicari.',
          position: 'bottom-right',
          isClosable: true,
        })
      });
    }
  }

  const downloadToExcel = async () => {
    await axios.get(URL_WEB_BACKEND + '/getallsumas', {
      headers: {
        'Authorization': 'Bearer ' + authdata
      }
    }).then((response) => {
      const worksheet = xlxUtils.json_to_sheet(response.data);
      const workbook = xlxUtils.book_new();
      xlxUtils.book_append_sheet(workbook, worksheet, "Sheet1");
      // let buffer = xlxWrite(workbook, { bookType: "xlsx", type: "buffer" });
      // xlxWrite(workbook, { bookType: "xlsx", type: "binary" });
      xlxWriteFile(workbook, "Disposisi_Surat_Masuk_LPP_Yogyakarta_Pertanggal_" + new Date().toISOString().slice(0, 10) + ".xlsx");
    }).catch(err => {
      toast({
        status: 'error',
        title: 'Error status ' + err.response.status,
        description: 'Data Semua Surat Keluar kosong.',
        position: 'bottom-right',
        isClosable: true,
      })
    });
  };

  return (
    <Card
      direction='column'
      w='100%'
      px='0px'
      overflowX={{ sm: "scroll", lg: "hidden" }}>
      <Flex px='25px' justify='space-between' mb='20px' align='center'>
        <Text
          color={textColor}
          fontSize='22px'
          fontWeight='700'
          lineHeight='100%'>
          Daftar Surat Masuk
        </Text>
        <Flex justify='space-between' align='end'>
          <Button
            variant='action'
            onClick={() => downloadToExcel()}>
            <Text
              fontSize='lg'
              as='b'>
              Ekspor Semua Data ke Excel
            </Text>
          </Button>
        </Flex>
      </Flex>
      <Table minH='600' variant='unstyled'>
        <TableCaption>
          {isPagination && allPageNumber >= 1 ?
            <Grid templateColumns="repeat(3, 1fr)" gap={2}>
              {currentPageNumber === 1 ? <Button disabled><ArrowBackIcon me='2' />Sebelum</Button> : <Button onClick={() => { setCurrentPageNumber(currentPageNumber - 1); setTimeout(() => getSumas(currentPageNumber - 1), 1000); }}><ArrowBackIcon me='2' />Sebelum</Button>}
              <Button>{currentPageNumber}</Button>
              {currentPageNumber === allPageNumber ? <Button disabled>Lanjut<ArrowForwardIcon ms='2' /></Button> : <Button onClick={() => { setCurrentPageNumber(currentPageNumber + 1); setTimeout(() => getSumas(currentPageNumber + 1), 1000); }}>Lanjut<ArrowForwardIcon ms='2' /></Button>}
            </Grid>
            : <Text as='b'>akhir dari tabel.</Text>
          }
        </TableCaption>
        <Thead><Tr>
          <Td>
            <Grid templateColumns="repeat(5, 1fr)" gap={2}>
              <Select borderRadius='16px' aria-label="Default" value={searchCat} onChange={(e) => setSearchCat(e.target.value)}>
                {catOpt.map((option) => (<option key={option.value} value={option.value}>{option.label}</option>))}
              </Select>
              <GridItem colSpan='4'>
                <Input variant='filled' id={"search" + searchClue} placeholder="Cari Surat Masuk" borderRadius="16px" value={searchClue} onChange={(e) => setSearchClue(e.target.value)} />
              </GridItem>
            </Grid>
          </Td>
        </Tr></Thead>
        <Tbody>
          {sumas.length < 1
            ? <Tr><Td><Center mb={6}>{statusLoading ? <Spinner thickness='4px' speed='0.95s' emptyColor='gray.200' color='blue.500' size='xl' /> : <>Belum ada surat masuk.</>}</Center></Td></Tr>
            : <>
              {sumas.map((datasumas, index) => (
                <Tr key={index} >
                  <Td>
                    <Card direction="row" p='6' boxShadow="md" m='2' borderRadius="lg">
                      {datasumas.isidisposisi !== '' || datasumas.disposisike !== '' ? <Badge colorScheme="green" width='30%' marginBottom={5}>SUDAH DISPOSISI</Badge> : <Badge colorScheme="red" width='30%' marginBottom={5}>BELUM DISPOSISI</Badge>}
                      <Grid templateColumns="repeat(2, 1fr)" gap={8}>
                        <Box w='100%'>
                          <Text as='b'>ISI RINGKAS</Text><HSeparator mb='1' />{datasumas.isisurat}<br /><br />
                          <Text as='b'>NOMOR SURAT</Text><HSeparator mb='1' />{datasumas.nosurat}<br /><br />
                          <Grid templateColumns="repeat(2, 1fr)" gap={1}>
                            <Box w='100%'>
                              <Text as='b'>TANGGAL SURAT</Text><HSeparator mb='1' />{convertDate(datasumas.tanggalsurat)}<br /><br />
                            </Box>
                            <Box w='100%'>
                              <Text as='b'>LAMPIRAN</Text><HSeparator mb='1' />{datasumas.lampiran}<br /><br />
                            </Box>
                          </Grid>
                          <Grid templateColumns="repeat(2, 1fr)" gap={1}>
                            <Box w='100%'>
                              <Text as='b'>ASAL SURAT & MEDIA PENGIRIMAN</Text><HSeparator mb='1' />{datasumas.dari}<br /><br />
                            </Box>
                            <Box w='100%'>
                              <Text as='b'>TANGGAL INPUT</Text><HSeparator mb='1' />{convertDate(datasumas.tanggal)}<br /><br />
                            </Box>
                          </Grid>
                          <Text as='b'>FILE SURAT</Text><HSeparator mb='1' />{datasumas.extfile === 'null' ? (<>-</>) : (<Button onClick={() => saveAs(URL_WEB_BACKEND + "/uploads/sumas/file/" + datasumas.verifid + '_' + datasumas.id_user + '.' + datasumas.extfile, 'SUMA-' + datasumas.tanggal + '-' + datasumas.nosurat + '.' + datasumas.extfile)}><DownloadIcon /> LIHAT DISINI</Button>)}<br /><br />
                          <Button
                            leftIcon={<ArrowForwardIcon />}
                            variant="outline"
                            colorScheme="blue"
                            ml={3}
                            onClick={() => {
                              if (!datasumas || !datasumas.verifid) return alert('Data tidak valid.');
                              const msgs = `Mohon izin Bapak/Ibu, izin mengirimkan disposisi dari Bapak Kalapas.\n\nSurat: ${datasumas.isisurat}.\n\nInformasi lebih detail dapat dilihat pada link berikut:\n\n${URL_WEB_FORNTEND}/#/verifikasi/suma/${datasumas.verifid}`;
                              navigator.clipboard.writeText(msgs);
                              alert(`PESAN TELAH DISALIN:\n\n${msgs}`);
                            }}> BAGIKAN</Button>
                        </Box>
                        <Box w='100%'>
                          <Text as='b'>PENGOLEH</Text>
                          <HSeparator mb='1' />
                          {datasumas.pengoleh}<br /><br />
                          <Grid templateColumns="repeat(2, 1fr)" gap={4}>
                            <Box w='100%'>
                              <Text as='b'>PARAF PENGOLEH</Text>
                              <HSeparator mb='2' />
                              <Image
                                src={datasumas.paraf}
                                bgColor='white'
                                borderRadius='16'
                                boxSize='200'
                                alt='paraf'
                                draggable='false'
                              />
                            </Box>
                            <Box w='100%'>
                              <Text as='b'>TUJUAN DISPOSISI</Text>
                              <HSeparator mb='2' />
                              <Stack spacing={1}>
                                {datasumas.disposisike && datasumas.disposisike.split(',').map((tujuan, index) => (
                                  <Checkbox key={index} isChecked={true} isReadOnly>{tujuan}</Checkbox>
                                ))}
                              </Stack>
                            </Box>
                          </Grid>
                          <Box mt={6}>
                            <Text as='b'>ISI DISPOSISI</Text>
                            <HSeparator mb='2' />
                            <Text whiteSpace='pre-line'>{datasumas.isidisposisi || '-'}</Text>
                          </Box>
                        </Box>
                      </Grid>
                    </Card>
                  </Td>
                </Tr>
              ))}
            </>
          }
        </Tbody>
      </Table>
    </Card>
  );
}
